import { atom } from "jotai";

import { GenerateDisputeNotesDTO } from "@/core/dto";
import { GenerateDisputeNotesUseCase } from "@/core/usecases/deduction";
import { GraphQlAdapter } from "@/infrastructure/adapters/graphQl";
import { DeductionDisputeRepository } from "@/infrastructure/repositories/deduction/DeductionDispute.repository";

const client = GraphQlAdapter.getInstance().getClient();
const disputeRepository = new DeductionDisputeRepository(client);

export const generateDisputeNotesAtom = atom(null, async (_get, _set, params: GenerateDisputeNotesDTO) => {
  return new GenerateDisputeNotesUseCase(disputeRepository).execute(params);
});
